function createImageCards(array){
    let layout = array.slice(0, 5).map(item => 
    `<a class='image-card' href='${item.linkUrl}'>
        <img class="image-card__img" src='${item.imageUrl}' alt="logo" />
    </a>`
    );

    $('.js-images-container').append(layout);
};

$(document).ready(function(){
    if($('.js-images-container').length && imagesDataArray){
        $('.js-images-container').addClass('active');
        createImageCards(imagesDataArray);
    }
});
